import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { WorkInProgressComponent } from './work-in-progress.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule
  ],
  declarations: [
    WorkInProgressComponent
  ],
  exports: [
    WorkInProgressComponent
  ],
})
export class WorkInProgressModule { }
